export default __webpack_public_path__ + "static/lilnadas-cards-story-3-480008c91354e8725ef0e7c55ff8894d.png";